export const PAGE_TITLE: any = {
  HOME: "Home",
  PRODUCTS: "Products",
  CONSULTANCY: "Consultancy",
  PRICING: "Pricing",
  INSIGHTS: "Insights",
  ABOUT: "About",
  ETHICS: "Ethics",
  INVESTOR_RELATIONS: "Investor Relations",
  LEGAL: "Legal",
};

export const PRODUCTS_ARRAY: any[] = [
  {
    type: "developer",
    title: "/Developer Hub",
    description:
      "For API engineers: a customizable testing environment to analyze and optimize calls.",
  },
  {
    type: "prompt",
    title: "/Prompt IDE",
    description:
      "For API engineers: a customizable testing environment to analyze and optimize calls.",
  },
  {
    type: "chat",
    title: "/Chat",
    description:
      "For API engineers: a customizable testing environment to analyze and optimize calls.",
  },
];

export const PERFORMANCE_ARRAY: any[] = [
  {
    title: "94.8",
    subTitle: "GSM8K BENCHMARK",
    description:
      "Tesseract 2 achieves 94.8% on the GSM8K benchmark for basic arithmetics, outperforming the competition that scores between 92-94.4%.",
  },
  {
    title: "90.08",
    subTitle: "MMLU BENCHMARK",
    description:
      "Qeleo Tesseract 2 sets a new industry standard by outperforming similar AI technologies with a remarkable 90.08% benchmark on the MMLU, showcasing its proficiency across 57 diverse subjects.",
  },
  {
    title: "96.8",
    subTitle: "HELLASWAG BENCHMARK",
    description:
      "With 96.8% accuracy score on the HellaSwag benchmark, Tesseract 2 excels in commonsense reasoning for everyday tasks, surpassing competitors whose scores range up to 95.3%.",
  },
];

export const INVESTOR_NAV_ARR: string[] = [
  "/Investors",
  "/News",
  "/Financials",
  "/Reporting",
  "/Filings",
  "/FAQ",
];

export const PRICING_NAV_ARR: string[] = ["Free", "Discovery", "Enterprise"];

export const FAQ_ARR: any[] = [
  {
    query: "What sets Qeleo apart from other enterprise AI providers?",
    solution:
      "Qeleo distinguishes itself through its proprietary AI model, Tesseract, which consistently outperforms competitors in benchmarks. Our solutions are tailored to integrate seamlessly with client systems, enhancing performance and driving growth while prioritizing security and scalability.",
  },
  {
    query: "How does Qeleo ensure the security of its AI solutions?",
    solution:
      "Qeleo distinguishes itself through its proprietary AI model, Tesseract, which consistently outperforms competitors in benchmarks. Our solutions are tailored to integrate seamlessly with client systems, enhancing performance and driving growth while prioritizing security and scalability.",
  },
  {
    query: "Can you describe Qeleo's revenue model?",
    solution:
      "Qeleo distinguishes itself through its proprietary AI model, Tesseract, which consistently outperforms competitors in benchmarks. Our solutions are tailored to integrate seamlessly with client systems, enhancing performance and driving growth while prioritizing security and scalability.",
  },
];

export const HEADER_NAV_ARRAY: any[] = [
  // {
  //   link: "/products",
  //   name: "/Products",
  // },
  {
    link: "/consultancy",
    name: "/Consultancy",
  },
  {
    link: "/pricing",
    name: "/Pricing",
  },
  {
    link: "/insights",
    name: "/Insights",
  },
  {
    link: "/ethics",
    name: "/Ethics",
  },
  {
    link: "/about",
    name: "/About",
  },
];

export const RESULT_ARRAY: any[] = [
  {
    index: "01",
    name: "Pioneer",
    description:
      "You're at the forefront of innovation, harnessing the full spectrum of artificial intelligence capabilities. You not only adopt the latest AI technologies but also drive their evolution, influencing the direction of AI applications within your industry. Your strengths lie in a robust infrastructure that supports AI experimentation and deployment, a culture that values data-driven decision-making, and a workforce skilled in leveraging AI tools. As a pioneer, you enjoy a competitive edge by optimizing operations, personalizing customer experiences, and generating new revenue streams through AI-driven insights and solutions.",
    resultDesc:
      "Qeleo regularly helps pioneers stay ahead by exploring untapped AI opportunities and refining innovation strategies. Start with a no-obligation conversation.",
  },
  {
    index: "02",
    name: "Advanced",
    description:
      "You've successfully integrated AI into many areas of your business. You demonstrate strong capabilities in processing and analyzing large datasets, and your AI systems are sophisticated enough to significantly enhance decision-making and operational efficiency. You have well-established data governance and AI ethics protocols, ensuring responsible use of AI. While you may not be the primary innovators in the AI space, your proactive approach allows you to capitalize on AI technologies effectively and maintain a strong position in the market.",
    resultDesc:
      "Engage in a no-obligation discussion with Qeleo to discover how to push your advanced AI initiatives into new frontiers of efficiency and market leadership.",
  },
  {
    index: "03",
    name: "Competent",
    description:
      "You've successfully integrated AI into your business operations, supporting your key objectives. You have a reliable infrastructure for AI deployment and a workforce with a good level of AI literacy. You've taken meaningful steps to incorporate AI into your processes, and while you may not be leading the charge in AI innovation, you keep up with current trends and are prepared to scale your AI initiatives when needed. Your key strength lies in your steady and strategic approach to AI adoption, ensuring you remain relevant and competitive.",
    resultDesc:
      "Qeleo offers a no-obligation conversation to help competent enterprises identify the next steps in their AI journey, enhancing their readiness and strategic implementation.",
  },
  {
    index: "04",
    name: "Emerging",
    description:
      "You're at the beginning of your AI journey, recognizing the importance of AI and exploring how it can benefit your operations. You may have initiated pilot projects or integrated basic AI tools into your workflows. While you've taken steps towards AI readiness, your infrastructure, data management practices, and staff expertise may not yet be fully developed to leverage AI's transformative potential. The key challenge is to accelerate your AI adoption to keep pace with more advanced competitors.",
    resultDesc:
      "Start a no-obligation conversation with Qeleo to accelerate your emerging AI efforts, bridging gaps in infrastructure and expertise to climb the AI readiness ladder.",
  },
  {
    index: "05",
    name: "Lagging",
    description:
      "You have the potential to unlock the power of AI. Embrace it meaningfully to realize its full potential. You may be constrained by outdated technology infrastructures, lack of skilled personnel, or insufficient strategic vision for AI implementation. This could lead to falling behind as you miss out on the efficiencies, cost savings, and innovation opportunities that AI can offer. The absence of AI initiatives may lead to a decline in competitive advantage, as you are unable to harness data insights and automation benefits that AI-ready competitors are capitalizing on. Your primary weakness is a reactive stance towards technological trends, which may result in missed opportunities and a struggle to meet evolving market demands.",
    resultDesc:
      "Qeleo can assist lagging enterprises in initiating their AI transformation with a no-obligation conversation, laying the groundwork for a future-focused AI adoption plan.",
  },
];

export const AUDIT_TYPE_ARRAY: any[] = [
  {
    name: "Roadmap",
    control: "roadmap",
    description:
      "A robust AI roadmap is essential for AI readiness, focusing on a clearly articulated approach, definitive leadership, and sound financial management. The key lies in not only devising a strategy but also in its precise communication, setting quantifiable goals, and ensuring its sustainability over time.",
    formData: [
      {
        question:
          "Does your organization have a roadmap in place for implementing AI-powered solutions?",
        control: "roadmapTimeline",
        options: [
          {
            answer: "Yes, our AI roadmap is clearly defined.",
            value: 5,
          },
          {
            answer: "No, we are in the midst of formulating an AI roadmap.",
            value: 4,
          },
          {
            answer: "No, we have not begun to formulate an AI roadmap.",
            value: 3,
          },
          {
            answer: "Unsure.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Who is responsible for the AI roadmap within your company, or is it managed more organically and in a decentralized way?",
        control: "roadmapResponsibility",
        options: [
          {
            answer: "Our AI roadmap has clear leadership and ownership.",
            value: 5,
          },
          {
            answer: "It's managed organically and decentralized.",
            value: 2,
          },
        ],
      },
      {
        question:
          "Has your company developed a financial strategy to support the sustainable funding of AI deployment initiatives?",
        control: "roadmapFinStrategy",
        options: [
          {
            answer:
              "Yes, we have both short-term and long-term financial strategies.",
            value: 5,
          },
          {
            answer: "Yes, but we only have a short-term financial strategy.",
            value: 4,
          },
          {
            answer:
              "No, however, we are in the process of developing a financial strategy.",
            value: 3,
          },
          {
            answer:
              "No, and we do not have plans to develop a financial strategy at this time.",
            value: 2,
          },
          {
            answer: "Unsure.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Is there a system to track and measure the impact of AI deployments or AI-powered solutions in your organization?",
        control: "roadmapTrack",
        options: [
          {
            answer: "Yes, we have a system with defined metrics.",
            value: 5,
          },
          {
            answer:
              "Yes, we have a system, but are still defining the metrics.",
            value: 4,
          },
          {
            answer:
              "No, but we plan to implement this within the next 12 months.",
            value: 3,
          },
          {
            answer:
              "No, and we do not anticipate implementing this within the next 12 months.",
            value: 2,
          },
          {
            answer: "Unsure.",
            value: 0,
          },
        ],
      },
      {
        question:
          "In terms of budget allocation, how does your company balance AI deployment with other technological investments?",
        control: "roadmapBudget",
        options: [
          {
            answer:
              "AI deployment is our top budgetary priority, with additional funds allocated.",
            value: 5,
          },
          {
            answer:
              "AI deployment is equally prioritized with other technology initiatives, with some additional funding.",
            value: 4,
          },
          {
            answer:
              "AI deployment is important, but requires reallocating funds from other technology areas.",
            value: 3,
          },
          {
            answer:
              "AI deployment's importance is contingent upon the implementation of other technology initiatives.",
            value: 2,
          },
          {
            answer: "Unsure.",
            value: 0,
          },
        ],
      },
    ],
  },
  {
    name: "Infrastructure",
    control: "infrastructure",
    description:
      "The success of AI initiatives hinges on robust infrastructure, encompassing high-performance computing resources and scalable networks. Equally critical is a fortified security framework and the long-term viability of the AI deployment. All these elements are integral to the effective implementation of AI.",
    formData: [
      {
        question:
          "Assess your organization's IT infrastructure's scalability and flexibility for AI projects:",
        control: "infrastructureScalability",
        options: [
          {
            answer: "Fully adaptable to any AI computational needs.",
            value: 5,
          },
          {
            answer: "Highly scalable with future AI demands in mind.",
            value: 4,
          },
          {
            answer:
              "Moderately scalable, enhancements needed for complex applications.",
            value: 3,
          },
          {
            answer:
              "Limited scalability, significant updates required for large AI projects.",
            value: 2,
          },
          {
            answer: "Not scalable",
            value: 0,
          },
        ],
      },
      {
        question:
          "Evaluate the availability and integration of dedicated GPU resources for AI workloads:",
        control: "gpuResources",
        options: [
          {
            answer:
              "Robust GPU infrastructure for current and future AI workloads.",
            value: 5,
          },
          {
            answer: "Adequate GPU resources for ongoing projects.",
            value: 3,
          },
          {
            answer: "Limited GPU resources for experimental use.",
            value: 2,
          },
          {
            answer: "No dedicated GPU resources available.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Determine the efficiency of compute resource allocation for AI tasks in your organization:",
        control: "computeResourceAllocation",
        options: [
          {
            answer:
              "Mostly automated systems that allocate resources based on AI demand.",
            value: 5,
          },
          {
            answer:
              "Some automated processes with occasional need for manual intervention.",
            value: 3,
          },
          {
            answer: "Manual resource allocation, potentially suboptimal.",
            value: 2,
          },
          {
            answer: "No structured approach to resource allocation for AI.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Rate your data center's network performance for AI workloads in terms of latency and throughput:",
        control: "networkPerformance",
        options: [
          {
            answer: "Optimal performance tailored for demanding AI workloads.",
            value: 5,
          },
          {
            answer:
              "Moderately optimal with rare issues, improvements needed for future demand.",
            value: 3,
          },
          {
            answer:
              "Suboptimal with occasional latency issues for large AI workloads.",
            value: 2,
          },
          {
            answer: "Not optimal with frequent issues and bottlenecks.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Assess your network's preparedness for growing complexity and data volume in AI projects:",
        control: "networkPreparedness",
        options: [
          {
            answer: "Fully flexible and adaptable to any scale of AI projects.",
            value: 5,
          },
          {
            answer: "Highly scalable, anticipating significant AI growth.",
            value: 4,
          },
          {
            answer: "Adequately scalable, periodic updates may be required.",
            value: 3,
          },
          {
            answer:
              "Somewhat scalable, potential bottlenecks for large AI projects.",
            value: 1,
          },
          {
            answer:
              "Not scalable, significant upgrades needed for large AI projects.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Evaluate the integration of your network infrastructure with AI systems for data flow and processing:",
        control: "networkIntegration",
        options: [
          {
            answer:
              "High-level integration for efficient data flow and seamless AI operations.",
            value: 5,
          },
          {
            answer: "Moderate integration with optimization of major pathways.",
            value: 3,
          },
          {
            answer: "Basic integrations, manual adjustments often needed.",
            value: 2,
          },
          {
            answer: "No integration, network and AI systems operate in silos.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Assess your organization's awareness of cybersecurity threats specific to AI and machine learning systems:",
        control: "cybersecurityAwareness",
        options: [
          {
            answer:
              "High awareness with comprehensive understanding and updated security protocols.",
            value: 5,
          },
          {
            answer: "Moderate awareness with preliminary precautions taken.",
            value: 3,
          },
          {
            answer: "Limited awareness without specific measures in place.",
            value: 2,
          },
          {
            answer: "Unaware of security threats specific to AI workloads.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Examine how your organization protects data in AI models during transit and at rest:",
        control: "dataProtection",
        options: [
          {
            answer:
              "End-to-end encryption with security audits and continuous monitoring.",
            value: 5,
          },
          {
            answer:
              "Advanced encryption in place, regular audits may be lacking.",
            value: 3,
          },
          {
            answer: "Basic encryption measures in place.",
            value: 2,
          },
          {
            answer: "No specific encryption or protection measures.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Determine how your organization detects and prevents tampering or adversarial attacks on AI models:",
        control: "tamperingPrevention",
        options: [
          {
            answer:
              "Fully equipped with proactive monitoring and timely countermeasures.",
            value: 5,
          },
          {
            answer:
              "Moderately equipped with protective measures, lacking real-time monitoring.",
            value: 3,
          },
          {
            answer:
              "Somewhat equipped with basic measures, lacking robust protection.",
            value: 2,
          },
          {
            answer:
              "Not equipped, cybersecurity for AI workloads not considered.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Review how your organization manages access control to AI systems and datasets:",
        control: "accessControl",
        options: [
          {
            answer:
              "Dynamic, granular access controls with real-time monitoring.",
            value: 5,
          },
          {
            answer: "Advanced role-based access controls with periodic audits.",
            value: 3,
          },
          {
            answer: "Basic role-based access, may lack regular updates.",
            value: 2,
          },
          {
            answer: "Access largely open, not specifically restricted.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Evaluate your company's readiness to deploy AI in terms of power consumption:",
        control: "powerConsumptionReadiness",
        options: [
          {
            answer:
              "Highly prepared with infrastructure optimized for AI power consumption.",
            value: 5,
          },
          {
            answer:
              "Somewhat prepared with measures for AI power consumption concerns.",
            value: 3,
          },
          {
            answer:
              "Not prepared, no specific measures for AI power consumption.",
            value: 1,
          },
          {
            answer: "Unsure.",
            value: 0,
          },
        ],
      },
    ],
  },
  {
    name: "Data",
    control: "data",
    description:
      "The foundation of effective AI lies in high-quality data, which necessitates well-organized, purified datasets from within the organization and trustworthy data from outside sources. Enhancing the skills of your workforce is also key to integrating and leveraging this data efficiently.",
    formData: [
      {
        question:
          "Evaluate the centralization of your organization's in-house data for AI initiatives:",
        control: "dataCentralization",
        options: [
          {
            answer:
              "Fully centralized: Our data is uniformly managed and easily accessible across the organization.",
            value: 5,
          },
          {
            answer:
              "Moderately centralized: Most data is in a unified system with some remaining silos.",
            value: 3,
          },
          {
            answer:
              "Partially fragmented: A mix of centralized databases and department-specific silos.",
            value: 1,
          },
          {
            answer: "Highly fragmented: Data is dispersed among various silos.",
            value: 0,
          },
        ],
      },
      {
        question: "Assess the readiness of your in-house data for AI projects:",
        control: "dataReadiness",
        options: [
          {
            answer:
              "Consistently pre-processed: Our data is perpetually primed for AI applications.",
            value: 5,
          },
          {
            answer:
              "Mostly pre-processed: A large portion of our data is prepared for AI use.",
            value: 3,
          },
          {
            answer:
              "Occasionally pre-processed: Select datasets are ready, others need more preparation.",
            value: 1,
          },
          {
            answer:
              "Rarely pre-processed: Extensive effort is required to make data AI-compatible.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Describe the access protocols for AI teams to utilize in-house data:",
        control: "dataAccessProtocols",
        options: [
          {
            answer:
              "Facilitative: Our procedures streamline data access for AI purposes.",
            value: 5,
          },
          {
            answer:
              "Balanced: Protocols exist without significant impediment to access.",
            value: 3,
          },
          {
            answer:
              "Somewhat restrictive: Access is possible but not optimized, causing delays.",
            value: 1,
          },
          {
            answer:
              "Restrictive: Stringent protocols slow down data accessibility.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Rate the integration of your analytics tools with AI platforms and data sources:",
        control: "toolIntegration",
        options: [
          {
            answer:
              "Fully integrated: Tools and systems are seamlessly interconnected.",
            value: 5,
          },
          {
            answer:
              "Moderately integrated: Most tools smoothly interface with primary data sources.",
            value: 3,
          },
          {
            answer:
              "Somewhat integrated: Some direct tool-data connections, others need manual linking.",
            value: 1,
          },
          {
            answer:
              "Not integrated: Tools and data interactions are predominantly manual.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Evaluate the capability of your analytics tools with AI-related datasets:",
        control: "toolCapability",
        options: [
          {
            answer:
              "Excellent: Tools are AI-centric, designed for complex tasks.",
            value: 5,
          },
          {
            answer: "Good: A mix of general and AI-specific analytics tools.",
            value: 3,
          },
          {
            answer:
              "Fair: Limited AI-specific enhancements, with reliance on general tools.",
            value: 1,
          },
          {
            answer:
              "Basic: Tools are not specialized for AI and are more generic.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Assess the adaptability of your analytics tools for AI projects:",
        control: "toolAdaptability",
        options: [
          {
            answer:
              "Highly adaptable: Tools evolve with project needs and are swiftly customizable.",
            value: 5,
          },
          {
            answer:
              "Moderately adaptable: Tools serve most AI needs with occasional external solutions.",
            value: 3,
          },
          {
            answer:
              "Somewhat adaptable: Tools are adequate for current projects but may falter with complexity.",
            value: 1,
          },
          {
            answer:
              "Not adaptable: Tools frequently fall short of project demands.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Gauge your staff's proficiency with analytics tools for AI projects:",
        control: "staffProficiency",
        options: [
          {
            answer:
              "Proficient: Staff skillfully utilize tools for maximum AI project efficiency.",
            value: 5,
          },
          {
            answer:
              "Moderate: Staff competently manage standard AI analytics tasks.",
            value: 3,
          },
          {
            answer:
              "Intermediate: Staff use tools but require help for advanced AI functions.",
            value: 1,
          },
          {
            answer:
              "Beginner: Staff need extensive training for effective tool use.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Determine the rigor of quality checks for external data in AI training:",
        control: "dataQualityCheck",
        options: [
          {
            answer:
              "Advanced: External data is subject to thorough quality controls and reviews.",
            value: 5,
          },
          {
            answer:
              "Intermediate: Systematic validation is in place for all external data.",
            value: 3,
          },
          {
            answer: "Basic: Some manual quality checks are performed.",
            value: 1,
          },
          {
            answer:
              "No systematic process: We lack a formal procedure for data quality checks.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Assess how your organization tracks data origins for AI models:",
        control: "dataOriginTracking",
        options: [
          {
            answer:
              "Detailed tracking: Comprehensive data lineage is maintained for transparency.",
            value: 5,
          },
          {
            answer:
              "Structured system: Data origins are tracked, though not universally applied.",
            value: 3,
          },
          {
            answer:
              "Basic tracking: Some origin tracking without extensive lineage details.",
            value: 1,
          },
          {
            answer:
              "No active tracking: We do not systematically monitor data origins.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Describe how your organization verifies data accuracy for AI models:",
        control: "dataAccuracyVerification",
        options: [
          {
            answer:
              "Continuous validation: Data accuracy is constantly checked and corrected in real time.",
            value: 5,
          },
          {
            answer:
              "Periodic verification: Teams regularly review data for accuracy.",
            value: 3,
          },
          {
            answer: "Occasional checks: Systematic verification is lacking.",
            value: 1,
          },
          {
            answer:
              "External reliance: We depend on third-party data accuracy without internal checks.",
            value: 0,
          },
        ],
      },
    ],
  },
  {
    name: "Compliance",
    control: "compliance",
    description:
      "AI compliance requires a steadfast dedication to protecting data privacy, maintaining data sovereignty, and promoting fairness. It is crucial to maintain transparency within algorithms, comply with international privacy regulations, and uphold data sovereignty to build trust and uphold ethical standards in AI.",
    formData: [
      {
        question:
          "Assess your organization's awareness of potential biases and fairness in AI data sets:",
        control: "biasAwareness",
        options: [
          {
            answer:
              "High awareness: We conduct regular training and maintain ongoing discussions about biases.",
            value: 5,
          },
          {
            answer:
              "Moderate awareness: We have occasional training and awareness initiatives.",
            value: 3,
          },
          {
            answer:
              "Limited awareness: Informal discussions occur, but there is no structured understanding.",
            value: 1,
          },
          {
            answer: "Not aware: Biases in data have not been addressed.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Does your organization have processes to detect biases and ensure fairness in AI data?",
        control: "biasDetectionProcess",
        options: [
          {
            answer:
              "We prioritize diversity in data and conduct consistent bias checks with ongoing monitoring and updates.",
            value: 5,
          },
          {
            answer:
              "We actively source diverse data and conduct periodic bias audits.",
            value: 3,
          },
          {
            answer: "We aim for diverse data without formal checks for biases.",
            value: 1,
          },
          {
            answer: "Bias detection is not currently a focus for us.",
            value: 0,
          },
        ],
      },
      {
        question:
          "How are biases and fairness issues addressed and corrected in your data?",
        control: "biasCorrection",
        options: [
          {
            answer:
              "We have a systematic approach to correcting biases, with teams dedicated to proactive bias prevention and fairness within data management.",
            value: 5,
          },
          {
            answer: "We handle biases on a case-by-case basis.",
            value: 3,
          },
          {
            answer: "We recognize biases but lack formal correction methods.",
            value: 1,
          },
          {
            answer: "There is no established process for bias rectification.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Evaluate the transparency of your AI algorithms' decision-making processes:",
        control: "algorithmTransparency",
        options: [
          {
            answer:
              "Highly transparent: Most decisions can be traced to specific inputs.",
            value: 5,
          },
          {
            answer:
              "Moderately transparent: Key decision factors are identifiable.",
            value: 3,
          },
          {
            answer:
              "Limited transparency: There is some insight, but it's not comprehensive.",
            value: 1,
          },
          {
            answer:
              "Completely opaque: Decision-making mechanisms are not understood.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Does your organization have systems to detect biases and ensure fairness in AI algorithms?",
        control: "algorithmBiasDetection",
        options: [
          {
            answer:
              "We perform regular, thorough automated and manual reviews to monitor for algorithmic biases.",
            value: 5,
          },
          {
            answer:
              "We have automated bias detection tools, though they're not consistently applied.",
            value: 3,
          },
          {
            answer: "We conduct occasional manual bias checks.",
            value: 1,
          },
          {
            answer: "We have no mechanisms for detecting biases in algorithms.",
            value: 0,
          },
        ],
      },
      {
        question:
          "What is your organization's understanding of global data privacy standards and compliance in AI projects?",
        control: "dataPrivacyCompliance",
        options: [
          {
            answer:
              "High understanding: We strictly comply, with regular audits and a proactive approach to global privacy norms.",
            value: 5,
          },
          {
            answer:
              "Moderate understanding: We have protocols, but there may be occasional lapses.",
            value: 3,
          },
          {
            answer: "Basic understanding without systematic compliance.",
            value: 1,
          },
          {
            answer: "Unaware of global privacy standards.",
            value: 0,
          },
        ],
      },
      {
        question:
          "How is data anonymization managed to protect privacy in AI datasets?",
        control: "dataAnonymization",
        options: [
          {
            answer:
              "We apply consistent anonymization techniques to all datasets.",
            value: 5,
          },
          {
            answer: "We use advanced anonymization methods for most datasets.",
            value: 3,
          },
          {
            answer: "We apply basic anonymization inconsistently.",
            value: 1,
          },
          {
            answer: "We do not anonymize data; it is used as is.",
            value: 0,
          },
        ],
      },
      {
        question:
          "In the event of a data breach or privacy violation, how prepared is your organization?",
        control: "dataBreachResponse",
        options: [
          {
            answer:
              "We have an advanced, regularly reviewed protocol with prepared response teams.",
            value: 5,
          },
          {
            answer:
              "We have a structured response plan, though it's infrequently updated.",
            value: 3,
          },
          {
            answer:
              "We have a basic response plan, but it's not comprehensive or rehearsed.",
            value: 1,
          },
          {
            answer: "We lack an established breach response protocol.",
            value: 0,
          },
        ],
      },
      {
        question:
          "How knowledgeable is your organization about data sovereignty laws across different regions?",
        control: "dataSovereignty",
        options: [
          {
            answer:
              "We have detailed knowledge and experts for various jurisdictions.",
            value: 5,
          },
          {
            answer: "We have a good grasp of the laws in major regions.",
            value: 3,
          },
          {
            answer: "We have basic awareness but lack detailed knowledge.",
            value: 1,
          },
          {
            answer: "We are not familiar with data sovereignty laws.",
            value: 0,
          },
        ],
      },
      {
        question:
          "How does your organization ensure compliance with local data sovereignty requirements?",
        control: "dataSovereigntyCompliance",
        options: [
          {
            answer:
              "We follow strict protocols to store and process data in accordance with local laws.",
            value: 5,
          },
          {
            answer:
              "We perform regular checks to comply with the sovereignty laws of major regions.",
            value: 3,
          },
          {
            answer: "We have basic protocols, but compliance is inconsistent.",
            value: 1,
          },
          {
            answer:
              "We have no specific protocols; data storage is based on convenience.",
            value: 0,
          },
        ],
      },
      {
        question:
          "How are cross-border data transfers managed in relation to data sovereignty laws?",
        control: "crossBorderTransfers",
        options: [
          {
            answer:
              "We conduct rigorous checks to ensure all transfers comply with local laws.",
            value: 5,
          },
          {
            answer: "We have structured protocols for most transfers.",
            value: 3,
          },
          {
            answer:
              "We are aware of the laws but may occasionally lapse in adherence.",
            value: 1,
          },
          {
            answer:
              "We do not account for sovereignty in cross-border data transfers.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Rate the comprehensiveness of your organization's AI policies and protocols:",
        control: "aiPolicies",
        options: [
          {
            answer: "Our policies are highly comprehensive.",
            value: 5,
          },
          {
            answer: "Our policies are moderately comprehensive.",
            value: 3,
          },
          {
            answer: "Our policies are limited in scope.",
            value: 1,
          },
          {
            answer: "We do not have established AI policies.",
            value: 0,
          },
        ],
      },
    ],
  },
  {
    name: "Human Resources",
    control: "hr",
    description:
      "AI readiness within HR relies on the level of specialized knowledge and skill within the organization, bolstered by a commitment to continuous learning and development. Embracing inclusivity is also critical, with strategies in place to make AI tools available and usable by everyone, regardless of their abilities.",
    formData: [
      {
        question:
          "Evaluate the availability of in-house talent necessary for successful AI implementation in your company:",
        control: "inHouseTalent",
        options: [
          {
            answer: "Very well resourced with the necessary in-house talent.",
            value: 5,
          },
          {
            answer: "Moderately well resourced with some talent in place.",
            value: 4,
          },
          {
            answer: "Moderately under resourced, lacking some key talent.",
            value: 3,
          },
          {
            answer: "Significantly under resourced in necessary AI expertise.",
            value: 2,
          },
          {
            answer: "Unsure about our resourcing levels.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Assess the ability of your staff to adopt and optimize the use of AI technologies:",
        control: "staffAdoption",
        options: [
          {
            answer:
              "Proficient: Our staff are highly skilled in maximizing AI tool potential.",
            value: 5,
          },
          {
            answer: "Moderate: Most staff competently manage AI-related tasks.",
            value: 3,
          },
          {
            answer:
              "Intermediate: Staff are capable but require assistance for advanced features.",
            value: 1,
          },
          {
            answer:
              "Beginner: There is a substantial need for training in AI technologies.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Has your company committed to training programs to enhance employee AI skills?",
        control: "aiTrainingPrograms",
        options: [
          {
            answer: "We rely on external vendors for staff AI training.",
            value: 5,
          },
          {
            answer:
              "We have established comprehensive in-house AI training programs.",
            value: 3,
          },
          {
            answer:
              "Training programs are not yet in place, but we plan to initiate them.",
            value: 1,
          },
          {
            answer: "Unsure about our commitment to AI training programs.",
            value: 0,
          },
        ],
      },
      {
        question:
          "Regarding talent management, how has your company addressed AI technology accessibility for differently abled employees?",
        control: "aiAccessibility",
        options: [
          {
            answer:
              "Accessibility is a fundamental component of our AI strategy and talent management.",
            value: 5,
          },
          {
            answer:
              "We've considered accessibility but haven't arrived at concrete solutions.",
            value: 3,
          },
          {
            answer:
              "We recognize the importance but don't have control over AI tool development.",
            value: 1,
          },
          {
            answer:
              "At present, accessibility has not been factored into our strategy.",
            value: 0,
          },
        ],
      },
    ],
  },
];

export const CLASSIFICATION_OBJ: any = {
  roadmap: {
    Pioneer: [20, 25],
    Advanced: [15, 19],
    Competent: [10, 14],
    Emerging: [5, 9],
    Lagging: [0, 4],
  },
  "roadmap+infrastructure": {
    Pioneer: [64, 80],
    Advanced: [48, 63],
    Competent: [32, 47],
    Emerging: [16, 31],
    Lagging: [0, 15],
  },
  "roadmap+infrastructure+data": {
    Pioneer: [104, 130],
    Advanced: [78, 103],
    Competent: [52, 77],
    Emerging: [26, 51],
    Lagging: [0, 25],
  },
  "roadmap+infrastructure+data+compliance": {
    Pioneer: [152, 190],
    Advanced: [114, 151],
    Competent: [76, 113],
    Emerging: [38, 75],
    Lagging: [0, 37],
  },
  "roadmap+infrastructure+data+compliance+hr": {
    Pioneer: [168, 210],
    Advanced: [126, 167],
    Competent: [84, 125],
    Emerging: [42, 83],
    Lagging: [0, 41],
  },
  "roadmap+infrastructure+data+hr": {
    Pioneer: [120, 150],
    Advanced: [90, 119],
    Competent: [60, 89],
    Emerging: [30, 59],
    Lagging: [0, 29],
  },
  "roadmap+infrastructure+compliance": {
    Pioneer: [112, 140],
    Advanced: [84, 111],
    Competent: [56, 83],
    Emerging: [28, 55],
    Lagging: [0, 27],
  },
  "roadmap+infrastructure+compliance+hr": {
    Pioneer: [128, 160],
    Advanced: [96, 127],
    Competent: [64, 95],
    Emerging: [32, 63],
    Lagging: [0, 31],
  },
  "roadmap+infrastructure+hr": {
    Pioneer: [80, 100],
    Advanced: [60, 79],
    Competent: [40, 59],
    Emerging: [20, 39],
    Lagging: [0, 19],
  },
  "roadmap+data": {
    Pioneer: [60, 75],
    Advanced: [45, 59],
    Competent: [30, 44],
    Emerging: [15, 29],
    Lagging: [0, 14],
  },
  "roadmap+data+compliance": {
    Pioneer: [108, 135],
    Advanced: [81, 107],
    Competent: [54, 80],
    Emerging: [27, 53],
    Lagging: [0, 26],
  },
  "roadmap+data+compliance+hr": {
    Pioneer: [124, 155],
    Advanced: [93, 123],
    Competent: [62, 92],
    Emerging: [31, 61],
    Lagging: [0, 30],
  },
  "roadmap+data+hr": {
    Pioneer: [76, 95],
    Advanced: [57, 75],
    Competent: [38, 56],
    Emerging: [19, 37],
    Lagging: [0, 18],
  },
  "roadmap+compliance": {
    Pioneer: [68, 85],
    Advanced: [51, 67],
    Competent: [34, 50],
    Emerging: [17, 33],
    Lagging: [0, 16],
  },
  "roadmap+compliance+hr": {
    Pioneer: [84, 105],
    Advanced: [63, 83],
    Competent: [42, 62],
    Emerging: [22, 41],
    Lagging: [0, 21],
  },
  "roadmap+hr": {
    Pioneer: [36, 45],
    Advanced: [27, 35],
    Competent: [18, 26],
    Emerging: [9, 17],
    Lagging: [0, 8],
  },
  infrastructure: {
    Pioneer: [45, 55],
    Advanced: [35, 44],
    Competent: [25, 34],
    Emerging: [12, 24],
    Lagging: [0, 11],
  },
  "infrastructure+data": {
    Pioneer: [84, 105],
    Advanced: [63, 83],
    Competent: [42, 62],
    Emerging: [21, 41],
    Lagging: [0, 20],
  },
  "infrastructure+data+compliance": {
    Pioneer: [132, 165],
    Advanced: [99, 131],
    Competent: [66, 98],
    Emerging: [33, 65],
    Lagging: [0, 32],
  },
  "infrastructure+data+compliance+hr": {
    Pioneer: [148, 185],
    Advanced: [111, 147],
    Competent: [74, 110],
    Emerging: [37, 73],
    Lagging: [0, 36],
  },
  "infrastructure+data+hr": {
    Pioneer: [100, 125],
    Advanced: [75, 99],
    Competent: [50, 74],
    Emerging: [25, 49],
    Lagging: [0, 24],
  },
  "infrastructure+compliance": {
    Pioneer: [92, 115],
    Advanced: [69, 91],
    Competent: [46, 68],
    Emerging: [23, 45],
    Lagging: [0, 22],
  },
  "infrastructure+compliance+hr": {
    Pioneer: [108, 135],
    Advanced: [81, 107],
    Competent: [54, 80],
    Emerging: [27, 53],
    Lagging: [0, 26],
  },
  "infrastructure+hr": {
    Pioneer: [60, 75],
    Advanced: [45, 59],
    Competent: [30, 44],
    Emerging: [15, 29],
    Lagging: [0, 14],
  },
  data: {
    Pioneer: [40, 50],
    Advanced: [30, 39],
    Competent: [20, 29],
    Emerging: [10, 19],
    Lagging: [0, 9],
  },
  "data+compliance": {
    Pioneer: [88, 110],
    Advanced: [66, 87],
    Competent: [44, 65],
    Emerging: [22, 43],
    Lagging: [0, 21],
  },
  "data+compliance+hr": {
    Pioneer: [104, 130],
    Advanced: [78, 103],
    Competent: [52, 77],
    Emerging: [26, 51],
    Lagging: [0, 25],
  },
  "data+hr": {
    Pioneer: [56, 70],
    Advanced: [42, 55],
    Competent: [28, 41],
    Emerging: [14, 27],
    Lagging: [0, 13],
  },
  compliance: {
    Pioneer: [48, 60],
    Advanced: [36, 47],
    Competent: [23, 35],
    Emerging: [12, 22],
    Lagging: [0, 11],
  },
  "compliance+hr": {
    Pioneer: [64, 80],
    Advanced: [48, 63],
    Competent: [32, 47],
    Emerging: [16, 31],
    Lagging: [0, 15],
  },
  hr: {
    Pioneer: [16, 20],
    Advanced: [12, 15],
    Competent: [9, 11],
    Emerging: [4, 8],
    Lagging: [0, 3],
  },
};

export const CONSULTANCY_CARD_ARRAY: any[] = [
  {
    index: "01",
    name: "Listen",
    backgroundColor: "surface-accent-color2",
    descriptionList: [
      "You tell us your business challenges.",
      "You describe what you’d like to achieve.",
    ],
  },
  {
    index: "02",
    name: "Propose",
    backgroundColor: "colors-accents-yellow-a",
    descriptionList: [
      "We’ll architect the solution to best fit your needs.",
      "We can suggest PoCs, trials, and full stack implementations.",
    ],
  },
  {
    index: "03",
    name: "Implement",
    backgroundColor: "surface-status-green",
    descriptionList: [
      "We’ll deliver a scalable, flexible and cost-effective solution.",
      "We aim for ease of integration and best-in-class documentation.",
    ],
  },
  {
    index: "04",
    name: "Attenuate",
    backgroundColor: "surface-status-error",
    descriptionList: [
      "Together we can fine tune the models for efficiency.",
      "This process helps to de-risk and demystify AI.",
    ],
  },
  {
    index: "05",
    name: "Support",
    backgroundColor: "surface-accent-color1",
    descriptionList: [
      "Our global support team is always on hand to help.",
      "Strong collaborations and relationships are in our DNA.",
    ],
  },
];

export const INSIGHTS_TYPES_ARRAY: string[] = [
  "/All",
  // "/News",
  "/Technical",
  "/Release Notes",
  "/Press",
  "/Opinion",
];

export const INSIGHTS_ARTICLES_ARRAY: any[] = [
  {
    id: 9,
    title: "AI Roadmap for Enterprise Success",
    type: "/Opinion",
    class: "opinion-bg",
    date: "JULY 2024",
    image: "insight_roadmap.png",
  },
  {
    id: 8,
    title: "Thinktime: Our transparent and scalable approach to enterprise AI billing",
    type: "/Technical",
    class: "technical-bg",
    date: "JULY 2024",
    image: "insight_thinktime.png",
  },
  {
    id: 7,
    title: "Explainer: Mixture of Experts",
    type: "/Technical",
    class: "technical-bg",
    date: "JUNE 2024",
    image: "insight_expert.png",
  },
  {
    id: 6,
    title: "WebSocket (WSS) vs Server-Sent Events (SSE) in AI Model Responses",
    type: "/Technical",
    class: "technical-bg",
    date: "JUNE 2024",
    image: "insight_wss_sse.png",
  },
  // {
  //   id: 3,
  //   title: "AI vs Machine Responses: How to Exploit the JSON’s Secrets",
  //   type: "/Technical",
  //   class: "technical-bg",
  //   date: "MAY 2024",
  //   image: "insight_ai_mc.png",
  // },
  {
    id: 5,
    title:
      "Transformative Tech: The Defining Role of AI in 2024’s Industrial Evolution",
    type: "/Opinion",
    class: "opinion-bg",
    date: "MAY 2024",
    image: "insight_transformative.png",
  },
  {
    id: 4,
    title: "Hallucinations: What it means when the AI starts to dream",
    type: "/Technical",
    class: "technical-bg",
    date: "APRIL 2024",
    image: "insight_hallucinations.png",
  },
  {
    id: 0,
    title:
      "Qeleo Launches New AI Environments for the Developer and Enterprise Markets",
    type: "/Press",
    class: "press-bg",
    date: "APRIL 2024",
    image: "insight_launch.png",
    isExternalLink: true,
    link: "https://www.prnewswire.com/news-releases/qeleo-launches-new-ai-environments-for-the-developer-and-enterprise-markets-302108923.html",
  },
  {
    id: 3,
    title:
      "Demystifying AI for the C-Suite: Understanding the Corporate AI Landscape",
    type: "/Opinion",
    class: "opinion-bg",
    date: "MARCH 2024",
    image: "insight_demistify.png",
  },
  {
    id: 2,
    title:
      "From Code to Content: How Generative AI is Reshaping the Business Landscape",
    type: "/Opinion",
    class: "opinion-bg",
    date: "FEBRUARY 2024",
    image: "insight_reshaping.png",
  },
  {
    id: 1,
    title:
      "Vector Embedding: Unlocking the power of natural language understanding",
    type: "/Release Notes",
    class: "release-bg",
    date: "JANUARY 2024",
    image: "insight_vector.png",
  }
];
